import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const RotationRole: React.FC = () => {
  const { locale } = useRouter();

  const GRAPH_09_ROTATION_BY_ROLE = [
    {
      label: locale === 'es' ? 'Administración de sistemas' : 'Sysadmin',
      value: 27
    },
    {
      label:
        locale === 'es'
          ? 'Scrum Máster o Agile Coach'
          : 'Scrum Máster & Agile Coach',
      value: 22
    },
    {
      label:
        locale === 'es'
          ? 'Devops, Infraestructura y SRE'
          : 'Devops, Infra & SRE',
      value: 20
    },
    {
      label: locale === 'es' ? 'Análisis de Datos y BI' : 'Data Analyst & BI',
      value: 20
    },
    {
      label: locale === 'es' ? 'Ventas y BizDev' : 'Sales & BizDev',
      value: 20
    },
    {
      label: locale === 'es' ? 'Desarrollo Full-Stack' : 'Full-Stack Dev',
      value: 18
    },
    {
      label: 'Machine Learning',
      value: 18
    },
    { label: locale === 'es' ? 'Liderazgo Técnico' : 'Tech Lead', value: 17 },
    { label: locale === 'es' ? 'QA y Testing' : 'QA & Testing', value: 17 },
    { label: locale === 'es' ? 'IT Management' : 'IT Manager', value: 17 },
    {
      label: locale === 'es' ? 'Desarrollo Backend' : 'Backend Dev',
      value: 16
    },
    {
      label: locale === 'es' ? 'Product Ownership' : 'Product Owner',
      value: 15
    },
    {
      label: locale === 'es' ? 'Engineering Management' : 'Engineering Manager',
      value: 15
    },
    {
      label: locale === 'es' ? 'Desarrollo Frontend' : 'Frontend Dev',
      value: 15
    },
    {
      label: 'Data Engineer',
      value: 14
    },
    {
      label:
        locale === 'es' ? 'Arquitectura de Software' : 'Software Architect',
      value: 13
    },
    {
      label: locale === 'es' ? 'Project Management' : 'Project Manager',
      value: 11
    },
    {
      label: locale === 'es' ? 'Research Developer' : 'Research Dev',
      value: 11
    },
    { label: locale === 'es' ? 'Data Science' : 'Data Scientist', value: 8 },
    {
      label: locale === 'es' ? 'Product Management' : 'Product Manager',
      value: 7
    },
    { label: locale === 'es' ? 'Desarrollo Mobile' : 'Mobile Dev', value: 1 }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer width="99%" height={640}>
          <BarChart data={GRAPH_09_ROTATION_BY_ROLE} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
            />
            <YAxis
              type="category"
              dataKey="label"
              tickLine={false}
              width={220}
            />
            <Tooltip
              cursor={{ fill: '#e6dfff' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="#7d64d6" barSize={12} radius={6} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default RotationRole;
